// extracted by mini-css-extract-plugin
export var section = "index-module--section--1YBgK";
export var Main_img = "index-module--Main_img--dlqBE";
export var bottomImgContainer = "index-module--bottomImgContainer--3FXip";
export var bottom_img = "index-module--bottom_img--1ErAr";
export var bottomImgContainer_title = "index-module--bottomImgContainer_title--11Hpn";